import React from "react";
import {
    List,
    ListItem,
    ListItemButton,
    Checkbox,
    Typography,
    styled,
    Box,
} from "@mui/material";
import { useResponsiveStyles } from "../../../styles/useResponsiveStyles";
export const MultiSelectList = ({
    options,
    selectedOptions,
    onOptionToggle,
    onSelectAll,
    isTierSelector,
}) => {
    const allSelected =
        options.length > 0 && selectedOptions.length === options.length;
    const { getFontSize, getContainerHeight } = useResponsiveStyles();
    const StyledBox = styled(List)`
        &::-webkit-scrollbar {
            width: 6px; // Width for vertical scrollbar
            height: 6px; // Height for horizontal scrollbar
            background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 3px;
            background-color: #bdbdbd;
        }

        &::-webkit-scrollbar-track {
            border-radius: 3px;
            background-color: #f5f5f5;
        }
    `;

    return (
        <StyledBox sx={{ maxHeight: "10rem", overflow: "auto" }}>
            <List disablePadding>
                {!isTierSelector && (
                    <ListItem disablePadding sx={{ padding: 0 }}>
                        <ListItemButton
                            onClick={onSelectAll}
                            sx={{
                                padding: 0,
                                ...getContainerHeight("filter-height"),
                            }}
                        >
                            <Checkbox
                                edge="start"
                                checked={allSelected}
                                indeterminate={
                                    selectedOptions.length > 0 && !allSelected
                                }
                                size="small"
                                sx={{
                                    color: "#ef4444",
                                    "&.Mui-checked": {
                                        color: "#ef4444",
                                    },
                                    "&.MuiCheckbox-indeterminate": {
                                        color: "#ef4444",
                                    },
                                    ml: 0.5,
                                }}
                            />
                            <Typography
                                sx={{
                                    ...getFontSize("body1"),
                                    fontWeight: 500,
                                }}
                            >
                                Select All
                            </Typography>
                        </ListItemButton>
                    </ListItem>
                )}

                {options.map((option) => (
                    <ListItem key={option.id} sx={{ padding: 0 }}>
                        <ListItemButton
                            onClick={() => onOptionToggle(option)}
                            sx={{
                                padding: 0,
                                display: "flex",
                                justifyContent: "space-between",
                                ...getContainerHeight("filter-height"),
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Checkbox
                                    edge="start"
                                    checked={selectedOptions.some(
                                        (item) => item.id === option.id
                                    )}
                                    size="small"
                                    sx={{
                                        color: "#ef4444",
                                        height: "12px",
                                        ml: 0.5,

                                        "&.Mui-checked": {
                                            color: "#ef4444",
                                        },
                                    }}
                                />
                                <Typography sx={{ ...getFontSize("body1") }}>
                                    {option.label} {"  "}
                                    <span style={{ color: "#ED1C24" }}>
                                        {option.count
                                            ? `(${option.count})`
                                            : null}
                                    </span>
                                </Typography>
                            </Box>
                            {option.color && (
                                <Box
                                    sx={{
                                        width: 9,
                                        height: 9,
                                        borderRadius: "50%",
                                        border: `2px solid ${option.color}`,
                                        marginRight: 1,
                                    }}
                                />
                            )}
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </StyledBox>
    );
};
